import { reportEvent, TYPES } from '../reports/reportEvent';
import tracker from '../reports/TrackingService';

export function getWorkSampleTypeByContentType(contentType) {
    if (contentType.startsWith('image')) {
        return 'image';
    }
    if (contentType.startsWith('video')) {
        return 'video';
    }
    if (contentType.startsWith('audio')) {
        return 'audio';
    }
    if (contentType.includes('pdf')) {
        return 'image';
    }
    return 'unknown';
}

export function reportClickEvent(eventData, position) {
    reportEvent(TYPES.workSampleClick.BigQuery, eventData);
    tracker.sendMixPanelEvent({
        eventName: TYPES.workSampleClick.Mixpanel,
        eventPayload: { position },
    });
}

export function reportHoverEvent(eventData, position) {
    reportEvent(TYPES.workSampleHover.BigQuery, eventData);
    tracker.sendMixPanelEvent({
        eventName: TYPES.workSampleHover.Mixpanel,
        eventPayload: { position },
    });
}
